module.exports = __webpack_public_path__ + "img/check-box.093c8390.svg";